import { Pipe, PipeTransform } from '@angular/core';
import { NumberPipe } from './number.pipe';

@Pipe({
  name: 'capitalize',
  standalone: true,
})
export class CapitalizePipe implements PipeTransform {
  private numberPipe: NumberPipe = new NumberPipe();

  transformNumber(value: string | number) {
    return this.numberPipe.transform(value);
  }

  transform(
    value: string | null | undefined,
    capitalizationMethod?: 'allUpperCase' | 'titleCase' | 'sentenceCase' | 'email' | 'number' | 'rates',
    skipIfMultipleUpperCase = false,
  ): string {
    if (value == null) return '';
    if (value == undefined) return '';
    if (skipIfMultipleUpperCase && (value.match(/[A-Z]/g) ?? []).length > 1) {
      return value;
    }
    if (capitalizationMethod === 'allUpperCase') {
      return value.toUpperCase();
    } else if (capitalizationMethod === 'titleCase') {
      // empty "words" (an empty value or double spaces) are kept as they are
      const splitString = value.split(' ').map((s) => (s ? `${s[0].toUpperCase()}${s.slice(1)}` : s));
      return splitString.join(' ');
    } else if (capitalizationMethod === 'email') {
      return value;
    } else if (capitalizationMethod === 'number') {
      return this.transformNumber(value);
    } else if (capitalizationMethod === 'rates') {
      const arr = value.split('/').map((val) => val.replace(' ', ''));
      const sub = arr.map((val) => this.transformNumber(val));
      return sub.join('/');
    } else if (capitalizationMethod === 'sentenceCase') {
      const splitString =
        value.indexOf('@') < 0
          ? // a dot followed by a digit is a decimal separator, not the end of a sentence
            value.split(/\.(?!\d)/).map((s) => {
              const trimmedString = s.trim();
              if (trimmedString.length > 0) {
                return `${trimmedString[0].toUpperCase()}${trimmedString.slice(1)}`;
              }
              return '';
            })
          : [`${value[0].toUpperCase()}${value.slice(1)}`];
      // a closing dot leaves an empty last part; don't leave a space after it
      return splitString.join('. ').trimEnd();
    } else if (!capitalizationMethod) {
      // Trim leading whitespace first so a stray space in a translation value
      // doesn't leave the first real character lowercase.
      const trimmed = value.trimStart();
      return trimmed.length > 0 ? `${trimmed[0].toUpperCase()}${trimmed.slice(1)}` : '';
    }
    return '';
  }
}
